"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPaymentMethod = formatPaymentMethod;
const payment_1 = require("../../enums/payment");
const country_1 = require("../enums/country");
const locales_1 = require("../enums/locales");
function formatPaymentMethod({ locale, paymentMethod, last4, country, }) {
    if (!paymentMethod ||
        paymentMethod === payment_1.PaymentMethod.Unknown ||
        paymentMethod === payment_1.PaymentMethod.Manual ||
        paymentMethod === payment_1.PaymentMethod.Transfer ||
        paymentMethod === payment_1.PaymentMethod.Stocks ||
        paymentMethod === payment_1.PaymentMethod.Pledge ||
        paymentMethod === payment_1.PaymentMethod.Invoice) {
        return "";
    }
    const last4Display = last4 ? ` (••• ${last4})` : "";
    const texts = {
        daf: {
            [locales_1.Locales.EN]: "Donor-advised fund (DAF)",
            [locales_1.Locales.FR]: "Fonds orienté par le donateur (DAF)",
            [locales_1.Locales.ES]: "Fondo asesorado por donantes (DAF)",
            [locales_1.Locales.DE]: "Spenderberatener Fonds (DAF)",
        },
        card: {
            [locales_1.Locales.EN]: `Card${last4Display}`,
            [locales_1.Locales.FR]: `Carte${last4Display}`,
            [locales_1.Locales.ES]: `Tarjeta${last4Display}`,
            [locales_1.Locales.DE]: `Karte${last4Display}`,
        },
        pad: {
            [locales_1.Locales.EN]: `Pre-Authorized Debit${last4Display}`,
            [locales_1.Locales.FR]: `Débit préautorisé${last4Display}`,
            [locales_1.Locales.ES]: `Débito preautorizado${last4Display}`,
            [locales_1.Locales.DE]: `Vorab autorisierte Lastschrift${last4Display}`,
        },
        ach: {
            [locales_1.Locales.EN]: `Direct Debit (ACH)${last4Display}`,
            [locales_1.Locales.FR]: `Débit direct (ACH)${last4Display}`,
            [locales_1.Locales.ES]: `Débito directo (ACH)${last4Display}`,
            [locales_1.Locales.DE]: `Lastschrift (ACH)${last4Display}`,
        },
        sepa: {
            [locales_1.Locales.EN]: `SEPA Direct Debit${last4Display}`,
            [locales_1.Locales.FR]: `Prélèvement SEPA${last4Display}`,
            [locales_1.Locales.ES]: `Débito directo SEPA${last4Display}`,
            [locales_1.Locales.DE]: `SEPA-Lastschrift${last4Display}`,
        },
        applePayOrGooglePay: {
            [locales_1.Locales.EN]: `Apple Pay / Google Pay${last4Display}`,
            [locales_1.Locales.FR]: `Apple Pay / Google Pay${last4Display}`,
            [locales_1.Locales.ES]: `Apple Pay / Google Pay${last4Display}`,
            [locales_1.Locales.DE]: `Apple Pay / Google Pay${last4Display}`,
        },
        cash: {
            [locales_1.Locales.EN]: "Cash",
            [locales_1.Locales.FR]: "Comptant",
            [locales_1.Locales.ES]: "Efectivo",
            [locales_1.Locales.DE]: "Bargeld",
        },
        cheque: {
            [locales_1.Locales.EN]: country === country_1.OrganizationCountry.UnitedStates ? "Check" : "Cheque",
            [locales_1.Locales.FR]: "Chèque",
            [locales_1.Locales.ES]: "Cheque",
            [locales_1.Locales.DE]: "Scheck",
        },
        inKind: {
            [locales_1.Locales.EN]: "In-kind",
            [locales_1.Locales.FR]: "En nature",
            [locales_1.Locales.ES]: "En especie",
            [locales_1.Locales.DE]: "Sachleistung",
        },
        other: {
            [locales_1.Locales.EN]: "Other",
            [locales_1.Locales.FR]: "Autre",
            [locales_1.Locales.ES]: "Otro",
            [locales_1.Locales.DE]: "Sonstige",
        },
        tapToPay: {
            [locales_1.Locales.EN]: "Tap to Pay",
            [locales_1.Locales.FR]: "Paiement sans contact",
            [locales_1.Locales.ES]: "Pago sin contacto",
            [locales_1.Locales.DE]: "Kontaktlos bezahlen",
        },
        cashApp: {
            [locales_1.Locales.EN]: "Cash App",
            [locales_1.Locales.FR]: "Cash App",
            [locales_1.Locales.ES]: "Cash App",
            [locales_1.Locales.DE]: "Cash App",
        },
        paypal: {
            [locales_1.Locales.EN]: "PayPal",
            [locales_1.Locales.FR]: "PayPal",
            [locales_1.Locales.ES]: "PayPal",
            [locales_1.Locales.DE]: "PayPal",
        },
        venmo: {
            [locales_1.Locales.EN]: "Venmo",
            [locales_1.Locales.FR]: "Venmo",
            [locales_1.Locales.ES]: "Venmo",
            [locales_1.Locales.DE]: "Venmo",
        },
        free: {
            [locales_1.Locales.EN]: "Free",
            [locales_1.Locales.FR]: "Gratuit",
            [locales_1.Locales.ES]: "Gratis",
            [locales_1.Locales.DE]: "Kostenlos",
        },
        inPersonCash: {
            [locales_1.Locales.EN]: "Cash (in-person)",
            [locales_1.Locales.FR]: "Comptant (en personne)",
            [locales_1.Locales.ES]: "Efectivo (en persona)",
            [locales_1.Locales.DE]: "Bargeld (persönlich)",
        },
    };
    return texts[paymentMethod]?.[locale] || "";
}
